module.exports = __webpack_public_path__ + "static/media/replay.c2b871f0.svg";